import React from "react";
import styles from "./panel.module.scss";

const PanelHeader: React.FC<{
  testId?: string;
  children?: React.ReactNode;
}> = ({ testId, children }) => {
  return (
    <div data-testid={testId} className={styles.panel_heading}>
      {children}
    </div>
  );
};

PanelHeader.displayName = "PanelHeader";
export { PanelHeader };
